// constants/fdaConfig.ts

// Offset de correction vertical pour l'affichage dans l'outil de repérage FDA
export const Y_OFFSET_TOOL_DISPLAY =-20;

// Offset de correction vertical pour la génération du PDF FDA
export const Y_OFFSET_PDF_GENERATION = -245;

// Offset de correction horizontal pour la génération du PDF FDA
export const X_OFFSET_PDF_GENERATION = -38;